import React from 'react';
import { ROLES } from '../../constants/roles';
import bionLogo from '../../assets/bion-logo.png';

const Sidebar = ({ user, currentPage, setCurrentPage, pages, onLogout, isOpen, setIsOpen }) => {
  const sidebarStyle = {
    width: isOpen ? '260px' : '80px',
    minHeight: '100vh',
    background: 'var(--surface)',
    borderRight: '1px solid var(--border)',
    display: 'flex',
    flexDirection: 'column',
    transition: 'width 0.3s ease',
    position: 'fixed',
    left: 0,
    top: 0,
    zIndex: 1000,
    overflowX: 'hidden'
  };

  const headerStyle = {
    padding: '24px 20px',
    borderBottom: '1px solid var(--border)',
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    minHeight: '80px'
  };

  const logoStyle = {
    fontSize: '32px',
    minWidth: '40px',
    textAlign: 'center'
  };

  const titleStyle = {
    fontSize: '20px',
    fontWeight: '700',
    color: 'var(--text-primary)',
    whiteSpace: 'nowrap',
    opacity: isOpen ? 1 : 0,
    transition: 'opacity 0.3s ease'
  };

  const navStyle = {
    flex: 1,
    padding: '20px 0',
    overflowY: 'auto'
  };

  const navItemStyle = (active) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: isOpen ? 'flex-start' : 'center',
    gap: isOpen ? '12px' : '0',
    padding: isOpen ? '12px 20px' : '12px',
    margin: '4px 12px',
    borderRadius: '8px',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    background: (active && isOpen) ? 'var(--primary)' : 'transparent',
    color: (active && isOpen) ? 'white' : 'var(--text-primary)',
    fontSize: '14px',
    fontWeight: active ? '600' : '500',
    border: 'none',
    width: 'calc(100% - 24px)',
    textAlign: 'left'
  });

  const iconStyle = {
    fontSize: '20px',
    minWidth: '24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  };

  const labelStyle = {
    whiteSpace: 'nowrap',
    opacity: isOpen ? 1 : 0,
    width: isOpen ? 'auto' : 0,
    overflow: 'hidden',
    transition: 'opacity 0.3s ease'
  };

  const footerStyle = {
    borderTop: '1px solid var(--border)',
    padding: '20px'
  };

  const userInfoStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    marginBottom: '16px'
  };

  const avatarStyle = {
    width: '40px',
    height: '40px',
    borderRadius: '50%',
    background: 'var(--primary)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'white',
    fontWeight: '700',
    fontSize: '16px',
    minWidth: '40px'
  };

  const userDetailsStyle = {
    opacity: isOpen ? 1 : 0,
    transition: 'opacity 0.3s ease',
    overflow: 'hidden'
  };

  const userNameStyle = {
    fontSize: '14px',
    fontWeight: '600',
    color: 'var(--text-primary)',
    marginBottom: '2px'
  };

  const userRoleStyle = {
    fontSize: '12px',
    color: 'var(--text-secondary)'
  };

  const toggleButtonStyle = {
    position: 'absolute',
    right: isOpen ? '12px' : '50%',
    transform: isOpen ? 'none' : 'translateX(50%)',
    top: isOpen ? '24px' : '28px',
    width: '40px',
    height: '40px',
    borderRadius: '50%',
    background: 'var(--surface)',
    border: '1px solid var(--border)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    fontSize: isOpen ? '16px' : '18px',
    color: 'var(--text-primary)',
    zIndex: 10,
    transition: 'all 0.3s ease'
  };

  const logoutButtonStyle = {
    width: '100%',
    padding: '10px',
    background: 'rgba(239, 68, 68, 0.1)',
    border: '1px solid rgba(239, 68, 68, 0.3)',
    borderRadius: '8px',
    color: '#ef4444',
    fontSize: '14px',
    fontWeight: '600',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: isOpen ? 'flex-start' : 'center',
    gap: '8px',
    transition: 'all 0.2s ease'
  };

  const icons = {
    dashboard: '',
    tickets: '',
    contracts: '',
    engineers: '',
    customers: '',
    company: '',
    reports: '',
    settings: '',
    emailTemplates: '',
    myTeam: '',
    myTickets: '',
    workReport: '',
    checklist: '',
    schedule: '',
    scheduleManagement: '',
    ticketManagement: '',
    createTicket: '',
    myContracts: '',
    support: '',
    logout: '',
    location: '',
    user: ''
  };

  return (
    <div style={sidebarStyle}>
      <button
        style={toggleButtonStyle}
        onClick={() => setIsOpen(!isOpen)}
        onMouseEnter={(e) => e.target.style.background = 'var(--primary-light)'}
        onMouseLeave={(e) => e.target.style.background = 'var(--surface)'}
      >
        {isOpen ? '<' : '>'}
      </button>

     <div style={headerStyle}>
        {isOpen && (
          <img
            src={bionLogo}
            alt="Bion Logo"
            style={{ width: '36px', height: '36px', objectFit: 'contain' }}
          />
        )}
        {isOpen && <div style={titleStyle}>AMC System</div>}
      </div>

      <nav style={navStyle}>
        {pages.map((page) => (
          <button
            key={page.id}
            style={navItemStyle(currentPage === page.id)}
            onClick={() => setCurrentPage(page.id)}
            onMouseEnter={(e) => {
              if (currentPage !== page.id) {
                e.target.style.background = 'var(--surface-light)';
              }
            }}
            onMouseLeave={(e) => {
              if (currentPage !== page.id) {
                e.target.style.background = 'transparent';
              }
            }}
          >
            <span style={iconStyle}>{icons[page.icon] || ''}</span>
            <span style={labelStyle}>{page.name}</span>
          </button>
        ))}
      </nav>

      <div style={footerStyle}>
        <div style={userInfoStyle}>
          <div style={avatarStyle}>
            {user?.name?.charAt(0).toUpperCase() || 'U'}
          </div>
          <div style={userDetailsStyle}>
            <div style={userNameStyle}>{user?.name || 'User'}</div>
            <div style={userRoleStyle}>{user?.role || 'Role'}</div>
          </div>
        </div>

        {isOpen && (
          <button
            style={logoutButtonStyle}
            onClick={onLogout}
            onMouseEnter={(e) => {
              e.target.style.background = 'rgba(239, 68, 68, 0.2)';
            }}
            onMouseLeave={(e) => {
              e.target.style.background = 'rgba(239, 68, 68, 0.1)';
            }}
          >
            <span>{icons.logout}</span>
            <span>Logout</span>
          </button>
        )}
      </div>
    </div>
  );
};

export default Sidebar;